import { Ico } from "../../components/icons/icons.jsx";

export function UserPermissionTag({ permission, onRemove, c, dark }) {
  return (
    <span
      style={{
        display: "inline-flex",
        alignItems: "center",
        gap: 8,
        border: `1px solid ${dark ? "rgba(255,255,255,0.12)" : "rgba(0,0,0,0.10)"}`,
        background: dark ? "rgba(255,255,255,0.06)" : "#fff",
        borderRadius: 999,
        padding: "7px 10px 7px 14px",
        fontSize: 12,
        fontWeight: 500,
        color: c.text,
        lineHeight: 1,
      }}
    >
      {permission}
      <button
        type="button"
        onClick={() => onRemove(permission)}
        aria-label={`Remove ${permission}`}
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          width: 18,
          height: 18,
          border: "none",
          borderRadius: 99,
          background: "transparent",
          color: "#ef4444",
          cursor: "pointer",
          padding: 0,
          flexShrink: 0,
        }}
        onMouseEnter={(e) => {
          e.currentTarget.style.background = dark ? "rgba(239,68,68,0.15)" : "rgba(239,68,68,0.08)";
        }}
        onMouseLeave={(e) => {
          e.currentTarget.style.background = "transparent";
        }}
      >
        {Ico.x}
      </button>
    </span>
  );
}
